import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { DomNodesTipService } from './dom-nodes-tip';
import { DomNodesTipServiceImpl } from './impls/dom-nodes-tip';

export const domNodesTipModule = (bind: interfaces.Bind) => {
    bind(DomNodesTipService).to(DomNodesTipServiceImpl);
};
